(() => {
  if (customElements.get('clette-bra-builder')) return;
  class BraBuilder extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.items = this.items || new Map();
      this.busy = false;
      this.step = this.step || 'bras';
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.emptyText = this.querySelector('[data-selections]').textContent.trim();
      this.addEventListener('click', e => this.click(e), {signal:this.events.signal});
      this.addEventListener('submit', e => this.select(e), {signal:this.events.signal});
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } }, {signal:this.events.signal});
      });
      this.render();
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; this.querySelectorAll('dialog[open]').forEach(d => d.close()); }
    click(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button) || button.disabled || this.busy) return;
      if (button.dataset.step || button.hasAttribute('data-next') || button.hasAttribute('data-back')) {
        this.step = button.dataset.step || (button.hasAttribute('data-next') ? 'undies' : 'bras');
        this.render();
        this.querySelector('.cbb-steps').scrollIntoView({block:'start',behavior:'instant'});
      } else if (button.dataset.open) {
        const dialog = this.querySelector(`[id="${CSS.escape(button.dataset.open)}"]`);
        dialog.showModal();
      } else if (button.hasAttribute('data-summary-toggle')) {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded)); button.textContent = expanded ? 'Hide items' : 'View items';
        this.querySelector('.gbbSideFooterHTML').classList.toggle('is-expanded', expanded);
      } else if (button.hasAttribute('data-close')) button.closest('dialog').close();
      else if (button.hasAttribute('data-variant')) {
        const form = button.closest('form');
        form.querySelectorAll('[data-variant]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        form.elements.id.value = button.dataset.variant;
        const qty = form.elements.quantity;
        qty.min = button.dataset.min; qty.step = button.dataset.increment;
        if (button.dataset.max) qty.max = button.dataset.max; else qty.removeAttribute('max');
        qty.value = button.dataset.min;
        form.querySelector('[data-add-selection]').disabled = false;
        form.querySelector('[data-add-selection]').textContent = 'Add to selection';
        button.closest('dialog').querySelector('[data-variant-price]').textContent = this.money.format(Number(button.dataset.price)/100);
      } else if (button.hasAttribute('data-image')) {
        const img = button.closest('dialog').querySelector('.cbb-modal-image');
        img.removeAttribute('srcset'); img.src = button.dataset.image;
      } else if (button.hasAttribute('data-clear')) { this.items.clear(); this.render(); }
      else if (button.dataset.remove) { this.items.delete(button.dataset.remove); this.render(); }
      else if (button.dataset.change) {
        const item = this.items.get(button.dataset.change);
        const next = item.quantity + Number(button.dataset.delta) * item.increment;
        if (next < item.min) this.items.delete(item.id);
        else if (!item.max || next <= item.max) item.quantity = next;
        this.render();
      } else if (button.dataset.submit) this.submitCart(button.dataset.submit);
    }
    select(event) {
      if (!event.target.matches('[data-selection-form]')) return;
      event.preventDefault();
      if (this.busy) return;
      const form = event.target, selected = form.querySelector('[data-variant][aria-pressed="true"]');
      if (!selected || !form.reportValidity()) return;
      const d = selected.dataset, quantity = Number(form.elements.quantity.value), old = this.items.get(d.variant);
      const total = quantity + (old?.quantity || 0);
      if (!Number.isSafeInteger(total) || total < Number(d.min) || (d.max && total > Number(d.max))) {
        form.elements.quantity.setCustomValidity('Please choose a quantity within the available limit.'); form.elements.quantity.reportValidity(); form.elements.quantity.setCustomValidity(''); return;
      }
      this.items.set(d.variant,{id:d.variant,group:d.group,title:d.title,options:d.options,image:d.image,price:Number(d.price),quantity:total,min:Number(d.min),increment:Number(d.increment),max:Number(d.max)||null});
      form.closest('dialog').close();
      this.render();
      this.querySelector('[data-message]').textContent = `${d.title} added to your selection.`;
    }
    node(tag, text, className) { const el = document.createElement(tag); if (text !== undefined) el.textContent = text; if (className) el.className = className; return el; }
    render() {
      const list = this.querySelector('[data-selections]'); list.replaceChildren();
      let count = 0, total = 0;
      for (const item of this.items.values()) {
        count += item.quantity; total += item.price * item.quantity;
        const line = this.node('div',undefined,'cbb-line'), img = this.node('img'); img.src = item.image; img.alt = item.title; img.width = 64; img.height = 76;
        const info = this.node('div'); info.append(this.node('p',item.title),this.node('small',item.options),this.node('small',this.money.format(item.price/100)));
        const controls = this.node('div',undefined,'cbb-line-controls');
        for (const delta of [-1,1]) { const b = this.node('button',delta < 0 ? '−' : '+'); b.type = 'button'; b.dataset.change = item.id; b.dataset.delta = delta; b.setAttribute('aria-label',`${delta < 0 ? 'Decrease' : 'Increase'} quantity of ${item.title}, ${item.options}`); if(delta === 1 && item.max && item.quantity + item.increment > item.max) b.disabled = true; controls.append(b); if(delta === -1) controls.append(this.node('span',String(item.quantity))); }
        info.append(controls);
        const remove = this.node('button','×','cbb-remove'); remove.type='button'; remove.dataset.remove=item.id; remove.setAttribute('aria-label',`Remove ${item.title}, ${item.options}`);
        line.append(img,info,remove); list.append(line);
      }
      if (!count) list.append(this.node('p',this.emptyText,'cbb-empty'));
      this.querySelector('[data-count]').textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
      const hasBras = [...this.items.values()].some(i => i.group === 'bras');
      const hasUndies = [...this.items.values()].some(i => i.group === 'undies');
      const complete = hasBras && hasUndies;
      if (!hasBras) this.step = 'bras';
      this.querySelectorAll('[data-panel]').forEach(p => p.hidden = p.dataset.panel !== this.step);
      this.querySelectorAll('[data-step]').forEach(b => { b.disabled = this.busy || (b.dataset.step === 'undies' && !hasBras); if (b.dataset.step === this.step) b.setAttribute('aria-current','step'); else b.removeAttribute('aria-current'); });
      const next = this.querySelector('[data-next]'); next.hidden = this.step !== 'bras'; next.disabled = this.busy || !hasBras;
      this.querySelector('[data-back]').hidden = this.step === 'bras';
      this.querySelector('[data-final-actions]').hidden = this.step === 'bras';
      this.querySelector('[data-offer]').textContent = complete ? '10% off your set · applied automatically in cart' : 'Complete your set and get 10% off.';
      const totalNode = this.querySelector('[data-total]'); totalNode.replaceChildren();
      if (complete) totalNode.append(this.node('s',this.money.format(total/100)), document.createTextNode(' '));
      totalNode.append(document.createTextNode(this.money.format((complete ? Math.round(total * .9) : total)/100)));
      this.querySelectorAll('[data-submit]').forEach(b => b.disabled = this.busy || !complete);
      this.querySelector('[data-clear]').disabled = this.busy || !count;
      this.querySelector('[data-message]').textContent = '';
    }
    async submitCart(destination) {
      if (this.busy || ![...this.items.values()].some(i => i.group === 'bras') || ![...this.items.values()].some(i => i.group === 'undies')) return;
      this.busy = true; this.render();
      const message = this.querySelector('[data-message]'); message.textContent = 'Adding your selection…';
      const root = this.dataset.root || '/';
      try {
        const response = await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[...this.items.values()].map(item=>({id:Number(item.id),quantity:item.quantity}))})});
        const result = await response.json();
        if (!response.ok) {
          this.busy = false; this.render();
          message.textContent = typeof result.description === 'string' ? result.description : 'Some sizes are unavailable. Review your selection and try again.';
          const link = this.node('a',' View cart'); link.href = `${root}cart`; message.append(link);
          return;
        }
        // Keep existing codes when asking Shopify to apply the builder offer.
        const currentResponse = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}});
        if (!currentResponse.ok) throw new Error('Cart read failed');
        const current = await currentResponse.json();
        const codes = [...new Set([...(current.discount_codes || []).map(d => d.code), this.dataset.discount])];
        const discountResponse = await fetch(`${root}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(',')})});
        if (!discountResponse.ok) throw new Error('Discount response failed');
        await discountResponse.json();
        this.items.clear();
        window.location.assign(destination === 'checkout' ? `${root}checkout` : `${root}cart`);
      } catch (error) {
        // An interrupted response may still have added items. Do not retry and double-add.
        message.textContent = 'We could not confirm the cart response. Check your cart before adding again.';
        const link = this.node('a',' View cart'); link.href = `${root}cart`; message.append(link);
      }
    }
  }
  customElements.define('clette-bra-builder',BraBuilder);
})();
